export const checkOnlyValidNicknameChar = (val: string) => {
  const regex = /^[a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9ぁ-ゔァ-ヴー々〆〤一-龥]+$/;
  return regex.test(val);
};

export const checkValidWordNicknameChar = (val: string) => {
  const regex = /[ㄱ-ㅎㅏ-ㅣ]/;
  return !regex.test(val);
};

export const checkSpaceNicknameChar = (val: string) => {
  const regex = /\s+/;
  return !regex.test(val);
};
